module.exports = __webpack_public_path__ + "static/media/SVID_S_1-2.64549223.png";